module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_27.f0bc2765.mp3";